import {useState} from "react";
import {useDebouncedState} from "@mantine/hooks";
import DefaultTable from "../../components/DefaultTable";
import {useGetClientsQuery} from "../../api/client";
import {IClient} from "../../api/types";
import PageContainer from "../../components/PageContainer";

const Clients = () => {
    const [page, setPage] = useState(1)
    const [search, setSearch] = useDebouncedState('', 200);
    const {data = {content: [], totalPages: 0}, isFetching} = useGetClientsQuery({page, pageSize: 10, search})

    function onRowClick(record: IClient) {

    }

    return (
        <PageContainer>
            <DefaultTable
                data={data}
                columns={[
                    {name: 'name', label: 'Имя Клиента'},
                    {name: 'phone', label: 'Номер телефона'},
                ]}
                onChangePage={setPage}
                isFetching={isFetching}
                page={page}
                onSearch={setSearch}
                enableSearch={true}
                searchPlaceholder={'Поиск по всем полям'}
                onRowClick={onRowClick}
            />
        </PageContainer>
    )
}

export default Clients;